// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-bell{font-size:50px;color:#fff;top:2vh;left:2vw;z-index:3;grid-column-start:2;position:fixed}.notification-bell:hover{color:grey;cursor:pointer}.notification-circle{text-align:center;border-radius:50px;width:1.4vw;height:2.5vh;left:3.5vw;top:4.5vh;z-index:3;background:red;position:fixed}.notifiation-number{color:#fff;position:relative;font-size:24px;bottom:6px}", ""]);
// Exports
module.exports = exports;
